// Facebook Pixel initialization utility
export const initFacebookPixel = () => {
  // Check if fbq already exists to avoid double initialization
  if (window.fbq) return;
  // Create and configure the fbq function
  window.fbq = function() {
    if (window.fbq.callMethod) {
      window.fbq.callMethod.apply(window.fbq, arguments);
    } else {
      window.fbq.queue.push(arguments);
    }
  };
  if (!window._fbq) window._fbq = window.fbq;
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = '2.0';
  window.fbq.queue = [];
  // Create script element
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  // Insert script into document head instead of relying on existing script tags
  document.head.appendChild(script);
  // Initialize pixel
  window.fbq('init', '527906828002058');
  window.fbq('track', 'PageView');
};
// Helper function to track custom events
export const trackFacebookPixelEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
};